// Announced on window so other modules can react to chat use without
// reaching into the per-project chat store.
export const CHAT_PANEL_OPENED_EVENT = 'counselpro:chat-panel-opened'

export const announceChatPanelOpened = () =>
  window.dispatchEvent(new Event(CHAT_PANEL_OPENED_EVENT))

// Asks an already-mounted chat panel to open, for links that stay on the
// same project page.
export const CHAT_PANEL_OPEN_REQUESTED_EVENT =
  'counselpro:chat-panel-open-requested'

export const requestChatPanelOpen = () =>
  window.dispatchEvent(new Event(CHAT_PANEL_OPEN_REQUESTED_EVENT))
